<template>
  <div class="material-wrapper">
    <div class="village-wrapper">
      <img src="../../assets/images/return.png" @click="$router.push({name: 'Index'})"><span @click="villageSelect(4)"><img src="../../assets/images/index-village.png">{{villageName}}<img src="../../assets/images/village-arrow.png" style="padding-top: 6px"></span>
    </div>
    <div class="classify-wrapper">
      <!-- <div class="item-title">常用</div> -->
      <div class="item-block" @click="$router.push({name: 'AssetList'})">
        <img src="../../assets/images/material-icon-assets-look.png">
        <div>资产查看</div>
      </div>
      <div class="item-block" @click="$router.push({name: 'GoodsList'})">
        <img src="../../assets/images/material-icon-assets.png">
        <div>物品档案</div>
      </div>
      <div class="item-block" @click="$router.push({name: 'RequisitionList'})" v-if="permissionSign.indexOf('requisition') >= 0">
        <img src="../../assets/images/material-icon-purchase-request.png">
        <div>采购申请</div>
      </div>
      <div class="item-block" @click="$router.push({name: 'AssetStocktakingList'})" v-if="permissionSign.indexOf('stocktaking') >= 0">
        <img src="../../assets/images/material-icon-inventory.png">
        <div>资产盘点</div>
      </div>
      <div class="item-block" @click="$router.push({name: 'StocktakingList'})" v-if="permissionSign.indexOf('stocktaking') >= 0">
        <img src="../../assets/images/material-icon-inventory.png">
        <div>耗材盘点</div>
      </div>
      <!-- <div class="item-block">
        <img src="../../assets/images/material-icon-consumable-collect.png">
        <div>耗材领用</div>
      </div>
      <div class="item-block">
        <img src="../../assets/images/material-icon-consumable-return.png">
        <div>耗材退还</div>
      </div>
      <div class="item-block">
        <img src="../../assets/images/material-icon-asset-collect.png">
        <div>资产领用</div>
      </div>
      <div class="item-block">
        <img src="../../assets/images/material-icon-asset-return.png">
        <div>资产退还</div>
      </div> -->
      <div class="item-block" @click="invoicelist(9, '维修出库')" v-if="permissionSign.indexOf('output') >= 0">
        <img src="../../assets/images/material-icon-repair-out.png">
        <div>维修出库</div>
      </div>
      <div class="item-block" @click="invoicelist(8, '耗材领用')" v-if="permissionSign.indexOf('output') >= 0">
        <img src="../../assets/images/material-icon-consumable-collect.png">
        <div>耗材领用</div>
      </div>
      <div v-if="enter_lists && permissionSign.indexOf('input') >= 0">
        <div class="item-block" v-for="(enter, enter_key) in enter_lists" :key="enter_key" @click="invoicelist(enter.delivery_type_id, enter.delivery_type_name)" v-if="permissionSign.indexOf('input') >= 0">
          <img src="../../assets/images/enter.png">
          <div>{{enter.delivery_type_name}}</div>
        </div>
      </div>
      <div v-if="out_lists && permissionSign.indexOf('output') >= 0">
        <div class="item-block" v-for="(out, out_key) in out_lists" :key="out_key" @click="invoicelist(out.delivery_type_id, out.delivery_type_name)" v-if="permissionSign.indexOf('input') >= 0">
          <img src="../../assets/images/out.png">
          <div>{{out.delivery_type_name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Material',
  metaInfo: {
    title: '物资管理'
  },
  computed: {
    ...mapState(['villageName', 'permissionSign', 'villageId', 'memberId'])
  },
  created () {
    this.getDeliveryType()
  },
  data () {
    return {
      enter_lists: [],
      out_lists: []
    }
  },
  methods: {
    // 选择小区
    villageSelect (e) {
      this.$router.push({name: 'Village', query: {index: e}})
    },
    invoicelist (id, name) {
      this.$router.push({name: 'InvoiceList', query: {delivery_type_id: id, title_info: name}})
    },
    getDeliveryType () {
      this.axios.post('/wechat/invoice/getDeliveryType', {
        village_id: this.villageId,
        member_id: this.memberId
      }).then((res) => {
        if (res.data.status === 1) {
          this.enter_lists = res.data.data.enter
          this.out_lists = res.data.data.out
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.material-wrapper {
  padding: 0 15px;
}
.material-wrapper .village-wrapper {
  text-align: left;
  padding: 15px 0 ;
  font-size: 18px;
}
.material-wrapper .village-wrapper img {
  width: 17px;
  height: 17px;
  vertical-align: top;
  padding: 4px 8px 0 0;
}
.material-wrapper .village-wrapper img:last-child {
  width: 14px;
  height: 14px;
  padding: 4px 0 0 4px;
}
.material-wrapper .classify-wrapper .item-title {
  font-size: 16px;
  margin-bottom: 10px;
}
.material-wrapper .classify-wrapper .item-block {
  width: 20%;
  float: left;
  text-align: center;
  margin: 6px 0;
}
.material-wrapper .classify-wrapper .item-block img {
  width: 60%;
  height: 60%;
}
.material-wrapper .classify-wrapper .item-block div {
  font-size: 14px;
  color: #6f6d6e;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Material.vue